export const HttpStatus = {
  BadRequestException: 400,
  Forbidden: 403,
  NotFoundException: 404,
  UnprocessableEntity: 422,
};
